import PinnedPost from '../post/PinnedPost';
import { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation, Outlet, useParams } from 'react-router-dom';
import UserContext from '../../../context/UserContext';
import PostApi from '../../../api/PostApi';
import PageNavigation from '../../pageNavigation/PageNavigation';
import { TodayTimestampDisplay } from '../../common/TimestampDisplay';
import Emergency from '../../icon/Emergency';
import HomeBanner, { HomeSectionBanner } from '../../banner/HomeBanner';
import { isToday, sub } from 'date-fns';
import TotalBoard from './TotalBoard';
import { getPostBaseUrl, getPostCategoryName, getPostNicknm, getPostLabelName, isOnlyAdmin } from '../../../constant/PostClass';
import { loginAlert } from '../../common/CustomAlert';
import ProgramList from './ProgramList';
import MiddleBanner from '../../banner/MiddleBanner';
import TotalBoardSec from './TotalBoardSec';
import ShortCut from './ShortCut';
import PopularSearchList from './PopularSearchList';
import { getRemovedTagContent } from '../../../util/StringUtil';
import MobileShortCutMenu from './MobileShortCutMenu';
import CardExpertProduct from './CardExpertProduct';
import CardMarketingProduct from './CardMarketingProduct';

const PAGE_SIZE = 20

const getParams = (search, key) => {
    const queryParams = new URLSearchParams(search);
    return queryParams.get(key) || null;
}

const Home = props => {
    const { postType = '', postLabel = '', usePinPost = false, postSectionTitle, children } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useContext(UserContext);
    const [ searchInput, setSearchInput ] = useState('');
    const [ isSearch, setIsSearch ] = useState(false);
    const [ totalCnt, setTotalCnt ] = useState(0);
    const [ posts, setPosts ] = useState([]);
    const [ page, setPage ] = useState(1);
    const [ annoucePosts, setAnnouncePosts ] = useState([]);

    const handleSearchInput = e => setSearchInput(e.target.value);
    
    const getPosts = async (props = {}) => {
        const { 
            newPage = page,
            newSize = PAGE_SIZE,
            newSearchKeyword = searchInput
        } = props;
        const rslt = await PostApi.getPosts(postType, newPage, newSize, false, null, newSearchKeyword, postLabel);
        setPosts(rslt.posts);
        setIsSearch((newSearchKeyword || '').trim().length > 0);
        if (newSearchKeyword) getTotalCount(newSearchKeyword);
    }
    
    const handleSearchInputKeyup = e => {
        if (e.which !== 13) return;
        handleSearchBtn();
    }

    const handleSearchBtn = (e, keywordFromTotalSearch) => {
        const newSearchKeyword = keywordFromTotalSearch ? keywordFromTotalSearch : searchInput.trim();
        getPosts({ newPage : 1, newSearchKeyword });
        setSearchInput(newSearchKeyword);
    }

    const handleWriteBtn = () => {
        if (!user.userId) return loginAlert('로그인이 필요합니다다.');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const endfix = ['PT00', 'PT01'].includes(postType) ? '1' : '0';
        const navPostType = postType.length === 4 ? postType + endfix : postType;
        navigate(`/post/write?postType=${navPostType}`);
    }

    const handleSearchCloseBtn = () => {
        setSearchInput('');
        getPosts({newSearchKeyword : ''});
    }

    const getTotalCount = async (newSearchKeyword) => {
        const rslt = await PostApi.getPostTotalCount(newSearchKeyword, postType, postLabel);
        setTotalCnt(rslt.totalCnt);
    }

    const handlePageChange = newPage => {
		if (!newPage) return;
		setPage(newPage);
		getPosts({ newPage });
	}

    const getAnnoucePosts = async () => {
        if (location.pathname === '/') return;
        const rslt = await PostApi.getAnnoucePosts(postType);
        if (rslt && rslt.posts) setAnnouncePosts(rslt.posts);
    }

    const isAdmin = () => {
        if (!isOnlyAdmin(postType)) return true;
        return user && user.userId && user.userType === 'admin';
    }

    useEffect(() => {
        setSearchInput();
        getAnnoucePosts();
        getTotalCount();
        const handleTotalSearchEvent = e => {
            handleSearchBtn(e, e.detail.totalSearchKeyword);
        }
        document.addEventListener("totalSearch", handleTotalSearchEvent);
        return () => {
            document.removeEventListener("totalSearch", handleTotalSearchEvent);
        }
    }, [postType, postLabel]);

    useEffect(() => {
        if (getParams(location.search, 'reload') === 'true') {
            getTotalCount();
            getPosts();
        }
    }, [location.search])

    return (
        <div className="vh-content-inner vw-inner">
            <div class="content-banner-row">
                <HomeBanner />
                <MobileShortCutMenu />
            </div>
            <div className='section-row'>
                <TotalBoard />
                <HomeSectionBanner />
            </div>
            <hr className="section-hr mo-only" />
            <CardExpertProduct />
            <hr className="section-hr mo-only" />
            <CardMarketingProduct />
            <hr className="section-hr mo-only" />
        </div>   
    )
}

export default Home;